import axios from 'axios';

export default {
  byType: (params = {}, config = {}) => axios.get('email-msgs/by-type', { params, ...config }),
};
